export const environment = {
  env: 'dev',
  production: false,
  apiBaseUrl: 'https://grandls-api.dsbase.de/api/',
  appVersion: '0.0.2',
};
